import React from 'react';
import styles from './Table.module.css';

export interface TableRowProps {
  children: React.ReactNode;
  columnWidths?: string[];
  onClick?: () => void;
  className?: string;
}

const TableRow: React.FC<TableRowProps> = ({ 
  children, 
  columnWidths,
  onClick,
  className = '' 
}) => {
  const gridTemplateColumns = columnWidths 
    ? columnWidths.join(' ') 
    : undefined;

  return (
    <div 
      className={`${styles.tableRow} ${onClick ? styles.tableRowClickable : ''} ${className}`}
      style={gridTemplateColumns ? { gridTemplateColumns } : undefined}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export default TableRow;

